import { Flex, Box, Text } from '@chakra-ui/react';
import { Button } from '@morressier/alembic';
import { useSubmissionData } from '../../../../contexts/SubmissionDataProvider';
import ProtectedWorkflowAction from 'src/components/ProtectedAction/ProtectedWorkflowAction';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRectangleHistoryCircleUser } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  onInviteReviewer: VoidFunction;
}

const EmptyReviewQueue = ({ onInviteReviewer }: Props) => {
  const { availableActions } = useSubmissionData();
  let CTA = <></>;

  const shouldShowCallToAction = true;
  if (shouldShowCallToAction) {
    CTA = availableActions.contains('EnqueueReviewRequest') ? (
      <ProtectedWorkflowAction actionName="EnqueueReviewRequest">
        <Button
          leftIcon={<FontAwesomeIcon icon={faRectangleHistoryCircleUser} />}
          onClick={onInviteReviewer}
        >
          Add Reviewers to Queue
        </Button>
      </ProtectedWorkflowAction>
    ) : (
      <Button variant="secondary" size="sm" isDisabled={true}>
        Inviting reviewers is not possible in the current workflow state.
      </Button>
    );
  }

  return (
    <Flex
      flexDirection="column"
      gap={2}
      alignSelf="flex-start"
      bgColor="neutralPrimaryFill"
    >
      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingItem">No Reviewers in Queue</Text>
        <Text textStyle="textBody">
          When inviting reviewers, you can add them to a queue as a backup list.
          The queue can advance reviewers manually or automatically, and you can
          reorder the queue as needed.
        </Text>
      </Flex>
      <Box>{CTA}</Box>
    </Flex>
  );
};

export default EmptyReviewQueue;
